import { TPayloadFlow, TPayloadList, TPayloadTerms } from './payload/types.ts';
import { MFE_URL } from '../utils/envConstants.ts';

export type TStaticConfig = TPayloadList<TPayloadFlow> & {
  terms?: TPayloadTerms[] | null;
};

export const fetchStaticConfig = async ({
  flowName,
  language,
}: {
  flowName: string;
  language: string;
}): Promise<TStaticConfig> => {
  const filePath = `${MFE_URL}/configs/${flowName}/${language}.json`;

  const response = await fetch(filePath);

  if (!response.ok) {
    throw new Error(`Failed to load ${filePath}`);
  }

  const contentType = response.headers.get('content-type') ?? '';

  if (!contentType.includes('json')) {
    throw new Error(`${filePath} returned ${contentType || 'no content type'}, not JSON`);
  }

  return (await response.json()) as TStaticConfig;
};
